import {
    RM_SOFTWARE_TICKET,
    RM_SOFTWARE_TICKET_FILTER
  } from "./type";
  
  const initalState = {
    rmSoftwareTicket: {},
    rmSoftwareTicketFilter: {},
  };
  
  const softwareRmTicketReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
      case RM_SOFTWARE_TICKET:
        return {
          ...state,
          rmSoftwareTicket: payload,
        };
      case RM_SOFTWARE_TICKET_FILTER:
        return {
          ...state,
          rmSoftwareTicketFilter: payload,
        };
      default:
        return {
          ...state,
        };
    }
  };
  
  export default softwareRmTicketReducer;
  